import React, { useState, useEffect } from "react";
import logo from "../../assets/images/logo.png";
import logo2 from "../../assets/images/logo.svg";

import { NavLink, useLocation } from "react-router-dom";

function Header() {
  const [toggle, setToggle] = useState(false);
  const handletogle = () => {
    setToggle(!toggle);
  };
  const location = useLocation();
  useEffect(() => {
    if (location.hash) {
      const anchor = document.querySelector(location.hash);
      if (anchor) {
        anchor.scrollIntoView({ behavior: "instant" });
      }
    }
  }, [location]);
  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };
  return (
    <>
      <header id="header" className="d-flex">
      <div className="mainlogo">
          <NavLink to={"/"}>
            <img src={"data:image/png;base64,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"} alt="logo" />
          </NavLink>
        </div>
        <div className="mainlogo2">
          <NavLink to={"/"}>
            <img src={"data:image/png;base64,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"} alt="logo" />
          </NavLink>
        </div>
        <nav
          className={`navbar ${toggle ? "show-list" : ""} d-flex`}
          id="mainListDiv"
        >
          <ul className="nav-list menulist d-flex">
            <li className="navigation ">
              <NavLink to={"/"}>Home</NavLink>
            </li>
            <li className="dropdown navigation">
              <NavLink to={"/about"} className="dropbtn d-flex">
                About
                <i>
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
              </NavLink>
              <div className="dropdown-content">
                {/* <NavLink to={"/about"} className="first">
                  Overview
                </NavLink> */}
                <NavLink to={"/about#our-mission"}  className="first">Our Mission</NavLink>
                <NavLink to={"/about#company-history"} className="last">
                  History
                </NavLink>
              </div>
            </li>
            <li className="dropdown navigation">
              <NavLink to={"/product"} className="dropbtn">
                Products
                <i>
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
              </NavLink>
              <div className="dropdown-content">
                <NavLink to={"/product#Comercio-affordable"} className="first">
                  Comercio
                </NavLink>
                <NavLink to={"/product#Medico"}>Medico</NavLink>
                <NavLink to={"/product#taxi"}>Transportation</NavLink>
                <NavLink
                  to={"/product#education"}
                  onClick={() => scrollToSection("education")}
                >
                  Education
                </NavLink>
                <NavLink
                  to={"/product#Examen"}
                  onClick={() => scrollToSection("Examen")}
                >
                  Examen
                </NavLink>
                <NavLink to={"/product#realestate"} className="last">
                  Real Estate
                </NavLink>
              </div>
            </li>
            <li className="dropdown navigation">
              <NavLink to={"/service"} className="dropbtn">
                Services
                <i>
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
              </NavLink>
              <div className="dropdown-content">
                <NavLink to={"/service/2"} className="first">Logo And Branding</NavLink>
                <NavLink to={"/service/8"}>UI/UX</NavLink>
                <NavLink to={"/service/1"}>Web Desiging</NavLink>
                <NavLink to={"/service/3"}>Android App Development</NavLink>
                <NavLink to={"/service/4"}>IOS App Development </NavLink>
                <NavLink to={"/service/5"}>Artificial Intelligence</NavLink>
                <NavLink to={"/service/6"}>It Support And Cloud Service</NavLink>
                <NavLink to={"/service/7"} className="last">Digital Marketing</NavLink>
              
              </div>
            </li>
            <li className="dropdown navigation">
              <NavLink to={"/career"} className="dropbtn">
                Career
                <i>
                  <svg
                    width="10"
                    height="6"
                    viewBox="0 0 10 6"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M1 1L5 5L9 1"
                      stroke="white"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </i>
              </NavLink>
              <div className="dropdown-content">
                <NavLink to={"/career"} className="first">
                  Apply For Job
                </NavLink>
                <NavLink to={"/internship"} className="last">
                  Apply For Internship
                </NavLink>
              </div>
            </li>
            <li className="dropdown navigation">
              <NavLink to={"/event"} className="dropbtn">
                Events
              </NavLink>
            </li>
          </ul>
          <ul className="nav-list hilighted-nav  contact-ul">
            <li>
              <NavLink to={"https://portfolio.mindcodelab.pro/"} target='_blank' rel="noreferrer"  className="btn btn-prp ">
                Portfolios
              </NavLink>
            </li>
          </ul>
        </nav>
        <span
          className={`navTrigger ${toggle ? "active" : ""}`}
          onClick={handletogle}
        >
          <i></i>
          <i></i>
          <i></i>
        </span>
      </header>
    </>
  );
}

export default Header;
